<template>

  <a-modal v-model:open="visible" title="Edit" cancel-text="Cancel" ok-text="Save" :confirm-loading="saveLoading"
    :mask-closable="false" width="720px" @cancel="handleCancel" @ok="handleSave">

    <div class="edit-tags-content">

      <div class="form-field">

        <label class="form-label">StoreID:</label>

        <a-input v-model:value="storeID" placeholder="Enter StoreID" :maxlength="50" />

      </div>



      <div class="form-field">

        <label class="form-label">CreatorID:</label>

        <a-input v-model:value="creatorID" placeholder="Enter CreatorID" :maxlength="128" />

      </div>



      <div class="creator-id-guide">

        <h5 class="creator-id-guide__title">How To Find Your CreatorID:</h5>

        <a-image :src="require('@/assets/images/storelDImg.png')" />

        <p class="creator-id-guide__example-label">E.g.</p>

        <p class="creator-id-guide__url">

          https://affiliate-program.amazon.com/p/connect/requests?creatorId=<span class="creator-id-guide__highlight">{{
            exampleCreatorId
            }}</span>&amp;status=opportunity&amp;type=affiliate-plus&amp;sortBy=recommended_for_you&amp;keyword=&amp;filterExpanderStatus=false&amp;categories=&amp;nonFullyClaimedOnly=false&amp;campaignStatuses=active%2Cpending&amp;topBrandsOnly=false&amp;creatorFavoritesOnly=false&amp;brands=&amp;contentType=&amp;budgetValue=

        </p>

        <p class="creator-id-guide__note">

          <strong>The blue highlighted part is the value you need to copy and save to ArtemisAds.</strong>

        </p>

      </div>



      <div class="marketplace-row">

        <span class="form-label">Marketplace:</span>

        <span class="marketplace-value">

          <Icon :name="resolveCountry(recordData.countryCode)?.icon" class="marketplace-icon" />

          {{ resolveCountry(recordData.countryCode)?.host || '—' }}

        </span>

      </div>

    </div>

  </a-modal>

</template>



<script setup>

import { ref, defineEmits, defineExpose } from 'vue'

import { message } from 'ant-design-vue'

import { associateTagsApi } from '@/server/publisher/associateTags'

import { COUNTRY_BASE } from '~/contants/common'

import Icon from '~/components/Icon.vue'



const emit = defineEmits(['refresh'])



const exampleCreatorId = 'amzn1.creator.67c4dea6-40bd-4fda-ac35-9face2cdc0b0'



const storeID = ref('')

const creatorID = ref('')

const visible = ref(false)

const recordData = ref({})

const currentTags = ref([])

const saveLoading = ref(false)



const resolveCountry = (code) => COUNTRY_BASE.find((item) => item.countryCode === code)



const open = (record) => {

  recordData.value = { ...record }

  currentTags.value = record?.associateTags ? [...record.associateTags] : []

  storeID.value = record?.storeId ?? ''

  creatorID.value = record?.creatorId ?? ''

  visible.value = true

}



const close = () => {

  visible.value = false

  resetForm()

}



const resetForm = () => {

  storeID.value = ''

  creatorID.value = ''

  recordData.value = {}

  currentTags.value = []

}



const handleCancel = () => {

  close()

}



const handleSave = async () => {

  saveLoading.value = true

  try {

    await associateTagsApi.addAssociateTag({

      countryCode: recordData.value.countryCode,

      associateTags: currentTags.value,

      storeId: storeID.value,

      creatorId: creatorID.value?.trim() || undefined,

    })

    message.success('Saved successfully')

    close()

    emit('refresh')

  } catch (error) {

    message.error('Save failed, please try again')

    console.error('Save tags error:', error)

  } finally {

    saveLoading.value = false

  }

}



defineExpose({

  open,

  close,

})

</script>



<style scoped lang="less">
.edit-tags-content {

  .form-field {

    margin-bottom: 20px;

  }



  .form-label {

    display: block;

    margin-bottom: 8px;

    font-family: Sora, sans-serif;

    font-size: 14px;

    font-weight: 500;

    line-height: 22px;

    color: #0f0629;

  }



  .creator-id-guide {

    margin-bottom: 24px;

    padding: 16px;

    border-radius: 8px;

    background: #f8f7fc;

    color: #0f0629;

    font-family: 'PingFang SC', Sora, sans-serif;

    font-size: 14px;

    line-height: 22px;



    &__title {

      margin: 0 0 12px;

      font-family: Sora, sans-serif;

      font-size: 14px;

      font-weight: 600;

      line-height: 22px;

      color: #0f0629;

    }



    &__steps {

      margin: 0 0 12px;

      padding-left: 20px;



      li {

        margin-bottom: 8px;



        &:last-child {

          margin-bottom: 0;

        }

      }

    }



    &__link {

      color: #7653da;

      word-break: break-all;



      &:hover {

        text-decoration: underline;

      }

    }



    &__code {

      margin: 0 2px;

      padding: 0 4px;

      border-radius: 4px;

      background: rgba(15, 6, 41, 0.06);

      font-size: 13px;

      word-break: break-all;

    }



    &__example-label {

      margin: 8px 0 8px;

      font-weight: 500;

    }



    &__url {

      margin: 0 0 12px;

      font-size: 12px;

      line-height: 20px;

      color: #5c5470;

      word-break: break-all;

    }



    &__highlight {

      color: #1677ff;

      font-weight: 500;

    }



    &__note {

      margin: 0;

      font-size: 14px;

      line-height: 22px;

      color: #0f0629;

    }

  }



  .marketplace-row {

    display: flex;

    align-items: center;

    gap: 8px;

    padding-top: 4px;

    border-top: 1px solid #e8e5ed;



    .form-label {

      margin-bottom: 0;

      flex-shrink: 0;

    }

  }



  .marketplace-value {

    display: inline-flex;

    align-items: center;

    gap: 6px;

    font-family: Sora, sans-serif;

    font-size: 14px;

    line-height: 22px;

    color: #0f0629;

  }



  .marketplace-icon {

    width: 20px;

    height: 20px;

    flex-shrink: 0;

  }

}
</style>
